import { participantConstants, commonConstants } from "../_constants";
import { apiCall } from "../_helpers";
import { appNotification } from "../_components";

const {
  GET_ALL_PARTICIPANTS_START,
  GET_ALL_PARTICIPANTS_SUCCESS,
  GET_ALL_PARTICIPANTS_FAILED,
  ADD_PARTICIPANT_START,
  ADD_PARTICIPANT_END,
  ADD_PARTICIPANT_FAILED,
  VIEW_PARTICIPANT_START,
  VIEW_PARTICIPANT_SUCCESS,
  VIEW_PARTICIPANT_FAILED,
  EDIT_PARTICIPANT_START,
  EDIT_PARTICIPANT_END,
  EDIT_PARTICIPANT_SUCCESS,
  EDIT_PARTICIPANT_FAILED,
} = participantConstants;

const { SUCCESSFUL_CODE, GLOBAL_LOADING_START, GLOBAL_LOADING_ENDED } =
  commonConstants;

const TEMP_BASE_URL = "https://automated-terminal-registration.k8.isw.la";

const getAllParticipants = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_PARTICIPANTS_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/participant/all`;
    apiCall
      .get(url)
      .then((response) => {
        const { status, message, content } = response.data;

        if (status !== SUCCESSFUL_CODE) {
          const error = {
            errorMessage: message,
          };
          dispatch({ type: GET_ALL_PARTICIPANTS_FAILED, payload: error });
          dispatch({ type: GLOBAL_LOADING_ENDED });
          return;
        }
        dispatch({
          type: GET_ALL_PARTICIPANTS_SUCCESS,
          payload: content,
        });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_ALL_PARTICIPANTS_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const viewParticipant = (id, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: VIEW_PARTICIPANT_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/participant/find?code=${id}`;
    apiCall
      .get(url)
      .then((response) => {
        const content = response.data;
        onSuccessCallback();
        dispatch({ type: VIEW_PARTICIPANT_SUCCESS, payload: content });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to get Participant's Details",
          "error"
        );
        dispatch({ type: VIEW_PARTICIPANT_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const createParticipant = (data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: ADD_PARTICIPANT_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/participant/create`;
    apiCall
      .post(url, data)
      .then((response) => {
        const { message, status } = response;
        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: ADD_PARTICIPANT_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: ADD_PARTICIPANT_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_PARTICIPANT_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "Participant has been created successfully",
              "Participant Added",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: ADD_PARTICIPANT_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(
          payload.errorMessage,
          "Unable to add Participant",
          "error"
        );
      });
  };
};

const editParticipant = (id, data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: EDIT_PARTICIPANT_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/participant/update/${id}`;
    apiCall
      .put(url, data)
      .then((response) => {
        const { status, message } = response;

        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: EDIT_PARTICIPANT_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: EDIT_PARTICIPANT_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_PARTICIPANT_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "Participant has been updated successfully",
              "Participant Updated",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: EDIT_PARTICIPANT_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(
          payload.errorMessage,
          "Unable to update Participant",
          "error"
        );
      });
  };
};

const participantActions = {
  getAllParticipants,
  viewParticipant,
  createParticipant,
  editParticipant,
};

export default participantActions;
